import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

const ELLIPSIS = -1;

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginationComponent {
  @Input() page = 1;
  @Input() pageSize = 20;
  @Input() totalItems = 0;
  @Input() pageSizeOptions: number[] = [10, 20, 50];

  @Output() readonly pageChange = new EventEmitter<number>();
  @Output() readonly pageSizeChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.max(1, Math.ceil(Math.max(0, this.totalItems) / this.safePageSize));
  }

  get currentPage(): number {
    return Math.min(Math.max(1, this.page), this.totalPages);
  }

  get pageNumbers(): number[] {
    const total = this.totalPages;
    const page = this.currentPage;

    if (total <= 7) {
      return Array.from({ length: total }, (_, index) => index + 1);
    }

    const pages = [1];
    if (page > 4) pages.push(ELLIPSIS);

    const start = Math.max(2, page - 1);
    const end = Math.min(total - 1, page + 1);
    for (let value = start; value <= end; value++) pages.push(value);

    if (page < total - 3) pages.push(ELLIPSIS);
    pages.push(total);
    return pages;
  }

  requestPage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.pageChange.emit(page);
  }

  onPageSizeSelected(value: number | string): void {
    const pageSize = Number(value);
    if (!Number.isFinite(pageSize) || pageSize <= 0 || pageSize === this.pageSize) return;
    this.pageSizeChange.emit(pageSize);
  }

  private get safePageSize(): number {
    return Number.isFinite(this.pageSize) && this.pageSize > 0 ? this.pageSize : 1;
  }
}
